<template>
    <div>
        <div class="mb-4 space-y-2">
            <div>
                <h1 class="text-2xl font-semibold text-gray-700">Telemedicine</h1>
                <p class="text-sm text-gray-500">Non-emergency video consultations</p>
            </div>

            <UTabs v-model="selected" :items="navigationLinks" :ui="tabsUi">
                <template #default="{ item }">
                    <div class="flex items-center space-x-2.5">
                        <UIcon :name="item.icon" class="w-4 h-4 flex-shrink-0" />
                        <span>{{ item.label }}</span>
                    </div>
                </template>
            </UTabs>
        </div>

        <NuxtPage />
    </div>
</template>

<script setup lang="ts">
import { UserRole } from '~/types/user'

definePageMeta({ layout: 'default', middleware: 'auth', roles: [UserRole.admin, UserRole.telemedicineAdmin, UserRole.telemedicineDoctor] })

const route = useRoute()
const router = useRouter()
const navigationLinks = useTelemedicineNav()

const selected = computed({
    get() {
        let best = -1
        navigationLinks.value.forEach((item, index) => {
            const matches = route.path === item.to || route.path.startsWith(item.to + '/')
            if (matches && (best === -1 || item.to.length > navigationLinks.value[best].to.length)) best = index
        })
        return best
    },
    set(value) {
        router.replace({ path: navigationLinks.value[value].to })
    },
})

const tabsUi = {
    wrapper: '-mx-4 sm:-mx-6 lg:-mx-8 space-y-0',
    container: 'border-b border-gray-300',
    list: {
        base: '!flex space-x-4 w-full overflow-x-auto sm:px-2 lg:px-4',
        background: 'bg-transparent',
        rounded: 'rounded-none',
        padding: 'p-0',
        height: 'h-auto',
        marker: {
            base: 'w-auto',
            wrapper: 'border-b-2 border-primary-600',
            background: 'bg-transparent',
            rounded: 'rounded-none',
            shadow: 'shadow-none',
        },
        tab: {
            base: 'h-auto w-auto',
            padding: 'px-4 py-2.5',
        },
    },
}
</script>
